import { render, staticRenderFns } from "./PaymentDocumentsTable.vue?vue&type=template&id=6329c0e1&"
import script from "./PaymentDocumentsTable.vue?vue&type=script&lang=ts&"
export * from "./PaymentDocumentsTable.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentDocumentsTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
